import { SettingOutlined } from '@ant-design/icons';
import { Tabs } from 'antd';
import { ReactElement } from 'react';
import EvaluationCriteria from './EvaluationCriteria';
import styles from './idea-channel-settings.module.less';
import IdeaMetrics from './IdeaMetrics';
import IdeaTagSettings from './IdeaTag';
import PhaseSettings from './Phase';
import SubmissionForm from './SubmissionForm';
import useTranslation from 'next-translate/useTranslation';

/* eslint-disable-next-line */
export interface IdeaChannelSettingsProps {}

export function IdeaChannelSettings(props: IdeaChannelSettingsProps) {
  const { t } = useTranslation('common');
  const Box = ({ children }: { children: ReactElement }) => {
    return <div className="max-h-[500px] overflow-auto">{children}</div>;
  };

  const items = [
    {
      key: 'criteria',
      label: t('evaluation_criteria'),
      children: (
        <Box>
          <EvaluationCriteria />
        </Box>
      ),
    },
    {
      key: 'tags',
      label: t('idea_tags'),
      children: (
        <Box>
          <IdeaTagSettings />
        </Box>
      ),
    },
    {
      key: 'phases',
      label: t('phases'),
      children: (
        <Box>
          <PhaseSettings />
        </Box>
      ),
    },
    {
      key: 'metric',
      label: t('idea_metrics'),
      children: (
        <Box>
          <IdeaMetrics />
        </Box>
      ),
    },
    {
      key: 'submission',
      label: t('submission_form'),
      children: (
        <Box>
          <SubmissionForm />
        </Box>
      ),
    },
  ];

  return (
    <div className={styles['container']}>
      <Tabs items={items} />
    </div>
  );
}

export default IdeaChannelSettings;
